import { Container, ContainerProps } from '@mantine/core';

type ResponsiveContainerProps = ContainerProps & {
  children: React.ReactNode;
};

export const ResponsiveContainer = ({ children, ...props }: ResponsiveContainerProps) => {
  return (
    <Container
      size="xl"
      px={{ base: 'md', sm: 'lg', md: 'xl' }}
      {...props}
    >
      {children}
    </Container>
  );
};